(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fumidar-size-guide')) {
    customElements.define('fumidar-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-guide-open]');
        this.opener.addEventListener('click', () => {
          this.dialog.showModal();
          this.querySelector('[data-guide-close]').focus({ preventScroll: true });
        });
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.opener.focus({ preventScroll: true }));
        this.querySelectorAll('[data-guide-unit]').forEach(button => button.addEventListener('click', () => this.setUnit(button.dataset.guideUnit, true)));
        let unit = 'cm';
        try { unit = localStorage.getItem('fumidar-size-unit') || 'cm'; } catch (error) { unit = 'cm'; }
        this.setUnit(unit, false);
      }
      setUnit(unit, announce) {
        unit = unit === 'inch' ? 'inch' : 'cm';
        this.dataset.unit = unit;
        this.querySelectorAll('[data-guide-cm]').forEach(cell => { cell.textContent = unit === 'inch' ? (Number(cell.dataset.guideCm) / 2.54).toFixed(2) : cell.dataset.guideCm; });
        this.querySelectorAll('[data-guide-unit-label]').forEach(label => { label.textContent = unit; });
        this.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
        if (announce) this.querySelector('[data-guide-status]').textContent = this.querySelector('caption').textContent;
        try { localStorage.setItem('fumidar-size-unit', unit); } catch (error) { }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
